import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'

const IconWrapper = styled.div`
  padding: 15px 0;

  @media ${device.mobileL} {
    padding-bottom: 20px;
  }

  @media ${device.tablet} {
    padding: 0.5208333333333334vw 0;
  }
`

const Wrapper = styled.div`
  background-color: #F3F3F3;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 20px 0;

  @media ${device.tablet} {
  ${''/* padding: 20px 0; */}
    padding: 1.0416666666666667vw 0;
  }
`

const TextWrapper = styled.div`
  padding: 10px 0;

  @media ${device.tablet} {
  ${''/* padding: 10px 0; */}
    padding: 0.5208333333333334vw 0;
  }
`

const Title = styled.h1`
  font-family: 'BarlowExtraBold';
  font-size: 32px;

  @media ${device.tablet} {
    font-size: 3.125vw;
  }
`

const SubTitle = styled.p`
  font-family: 'BarlowSemiBold';
  font-family: 16px;

  @media ${device.tablet} {
    font-size: 1.25vw;
  }
`

const Banner = ({ icon, title, subtitle }) => {
  return (
    <Wrapper>
      {icon && <IconWrapper>
        {icon}
      </IconWrapper>}
      <TextWrapper>
        {/* <Typography variant='h1' type='title'>{title}</Typography> */}
        <Title>{title}</Title>
      </TextWrapper>
      {subtitle && <TextWrapper>
        {/* <Typography variant='h5' type='subtitle'>{subtitle}</Typography> */}
        <SubTitle>{subtitle.split(';').map((item, key) => {
          return <span key={key}>{item}<br /></span>
        })}</SubTitle>
      </TextWrapper>}
    </Wrapper>
  )
}

Banner.propTypes = {
  /**
   * Title of the banner
   */
  title: PropTypes.string.isRequired,

  /**
   * subtitle of the Banner
   */
  subtitle: PropTypes.string,

  /**
   * Icon used for the feature
   */
  icon: PropTypes.node
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/Calculator/Banner/index.js